export enum DirectScheduleStatus {
  DISABLED = 'disabled',
  PENDING_DISABLE = 'pending_disable',
  ENABLED = 'enabled',
  PENDING_ENABLE = 'pending_enable'
}
